const addAppUidToMetafield = () => {
  let url =
    'https://mfxzhjcv22.execute-api.ap-northeast-1.amazonaws.com/dev/app-uid-add'
  const hostname = window.Shopify.shop
  if (
    hostname.includes('francfrancjp') ||
    window.location.host == 'francfranc.com'
  ) {
    url =
      'https://8tncooct88.execute-api.ap-northeast-1.amazonaws.com/prod/app-uid-add'
  }
  if (
    globalThis.FFJP.userID &&
    Object.prototype.hasOwnProperty.call(window.localStorage, 'app_uid')
  ) {
    if (window.localStorage.app_uid !== globalThis.FFJP.appUID) {
      const customer = globalThis.FFJP.userID
      const uid = window.localStorage.getItem('app_uid')
      const requestBody = {
        uid: uid,
        customerId: customer,
      }
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(requestBody),
      })
        .then(() =>
          // eslint-disable-next-line no-console
          console.log('uid updated')
        )
        .catch((err) =>
          // eslint-disable-next-line no-console
          console.log(err)
        )
    }
    window.localStorage.removeItem('app_uid')
  }
}

export default addAppUidToMetafield
